function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40",
  height: "41",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8.74 34.204L6.25 32.25V8.752L8.74 6.8v27.405zM20.352 34.25l-5.807-1.962V8.712l5.807-1.962v27.5zM33.75 34.25l-10.906-1.877V8.713L33.75 6.75v27.5z",
  fill: "var(--spectrum-logo-color)"
})));